const userDetails={
    name:"",
    mobile:null,
    email:"",
    address:""
}

export const InitialState={
    cartItemLength:0,
    userDetails:userDetails,
    cartItem:[]
}

